import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useSeventhAnalyses from 'hooks/useSeventhAnalyses';
import { seventhAnalysesSelectors } from "features/seventhAnalyses";

const SeventhAnalysesList = () => {
  const { getSeventhAnalyses } = useSeventhAnalyses();
  const { data, pagination } = useCustomSelector(seventhAnalysesSelectors.getSeventhAnalysesData);
  const fetching = useCustomSelector(seventhAnalysesSelectors.seventhAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getSeventhAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SeventhAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);